const util = {}
util.apiUrl = function () {
  return hostMethods().url
}
util.imgkey = function () {
  return hostMethods().imgfile
}
util.zturl = function () {
  return hostMethods().zturl
}
util.hfurl = function () {
  return hostMethods().hfurl
}
util.cloudurl = function () {
  return hostMethods().cloudurl
}
function hostMethods() {
  let url = '' // 接口访问路径
  let imgfile = '' // 根据平台网址区分图片路径
  let zturl = "" // 访问中台路径
  let hfurl = "" // 访问中台路径
  const host = document.domain //获取域名
  const port = location.port //获取端口号
  const protocol = window.location.protocol
  switch (host) {
    case 'xmedu.topeti.com': // 学校
    case 'eduxm.topeti.com':
      url = 'https://eduxm.topeti.com'
      zturl = 'https://xmeduzt.topeti.com/'
      imgfile = 'mainPlatform'
      break
    case 'xm.sszx.cn': // 双十
      url = 'https://xm.sszx.cn'
      zturl = 'https://xm.sszx.cn:80/'
      imgfile = 'mainPlatform'
      break
    case '10.95.249.6': // 翔安封闭
      url = 'http://10.95.249.6'
      zturl = 'http://10.95.249.6:8080/'
      imgfile = 'mainPlatform'
      break
    case 'user.topeti.com': // 翔安开放
      url = 'https://user.topeti.com'
      zturl = 'https://mp.topeti.com/'
      hfurl = 'https://app.topeti.com'
      imgfile = 'mainPlatform'
      break
    case 'jjyz.topeti.com': // 阿里
      url = 'https://user.topeti.com'
      zturl = 'https://mp.topeti.com/'
      hfurl = 'https://app.topeti.com'
      imgfile = 'mainPlatform'
      break
    case 'open.wcsjyj.com': // 华成云（新）
      url = 'https://open.wcsjyj.com:8090'
      zturl = 'https://zt.wcsjyj.com:8090/'
      imgfile = 'huachengyun'
      break
    case 'bsywgj.xmgongyema.com': // 厦物研工业
      if (port == "") {
        url = 'http://bsywgj.xmgongyema.com'
        zturl = 'http://bsywjsy.xmgongyema.com/'
      }
      else {
        url = 'http://bsywgj.xmgongyema.com:' + port
        zturl = 'http://bsywjsy.xmgongyema.com:' + port + '/'
      }
      imgfile = 'huachengyun'
      break
    case 'guanli.xmjmedu.com': // 集美教育局
      url = 'https://guanli.xmjmedu.com'
      zturl = 'https://glzt.xmjmedu.com/'
      imgfile = 'xmjmedu'
      break
    case 'mh.xmjmedu.com': // 集美教育局
      url = 'https://guanli.xmjmedu.com'
      zturl = 'https://glzt.xmjmedu.com/'
      imgfile = 'xmjmedu'
      break
    case 'xmjmedu.com': // 集美教育局
      url = 'https://guanli.xmjmedu.com'
      zturl = 'https://glzt.xmjmedu.com/'
      imgfile = 'xmjmedu'
      break
    case 'www.xmjmedu.com': // 集美教育局
      url = 'https://guanli.xmjmedu.com'
      zturl = 'https://glzt.xmjmedu.com/'
      imgfile = 'xmjmedu'
      break
    case '47.118.35.13': // 阿里
      url = 'http://47.118.35.13:80'
      zturl = 'http://47.118.35.13/'
      imgfile = 'mainPlatform'
      break
    case 'smart-aerospace.xmu.edu.cn': // 厦大航院
      url = 'https://smart-aerospace.xmu.edu.cn'
      zturl = 'https://smart-aerospace2.xmu.edu.cn/'
      imgfile = 'mainPlatform'
      break
    case '172.27.66.179': // 厦大航院
      url = 'http://172.27.66.179'
      zturl = 'http://172.27.66.180/'
      imgfile = 'mainPlatform'
      break
    case 'idata.xmu.edu.cn': // 厦大学情
      // 郑工说根据协议读取接口地址
      url = `${protocol}//idata.xmu.edu.cn`
      zturl = `${protocol}//172.27.66.91:8091/`
      imgfile = 'mainPlatform'
      break
    case '172.27.66.91': // 厦大学情
      url = 'http://172.27.66.91:80'
      zturl = 'http://172.27.66.91:8091/'
      imgfile = 'mainPlatform'
      break
    case 'wskjzs.longyanedu.net': // 龙岩
      url = 'https://wskjzs.longyanedu.net'
      zturl = 'https://wskjzt.longyanedu.net/'
      hfurl = 'http://wskjzzr.longyanedu.net'
      imgfile = 'mainPlatform'
      break
    case 'app.itgedu.com.cn': // 国贸教育
      url = 'http://app.itgedu.com.cn'
      zturl = 'http://admin.itgedu.com.cn/'
      imgfile = 'mainPlatform'
      break
    case '10.66.99.244': // 国贸教育
      if (port == "") {
        url = 'http://10.66.99.244'
      }
      else {
        url = 'http://10.66.99.244:' + port
      }
      zturl = 'http://10.66.99.244:4434/'
      imgfile = 'mainPlatform'
      break
    case '192.168.8.111': // 金砖标准院
      url = 'http://192.168.8.111'
      zturl = 'http://192.168.8.111:5091/'
      imgfile = 'mainPlatform'
      break
    case 'ty.topeti.com': // 移动托育平台
      url = 'https://ty.topeti.com:4443'
      zturl = 'https://tyzt.topeti.com:4443/'
      imgfile = 'mainPlatform'
      break
    case 'npuser.topeti.com': // 南平
      url = 'https://npuser.topeti.com:9843'
      zturl = 'https://npzt.topeti.com:9843/'
      hfurl = 'https://xgbmfw.npbigdata.com.cn'
      imgfile = 'mainPlatform'
      break
    case '172.25.129.161': // 南平政务内网
      url = 'http://172.25.129.161'
      zturl = 'http://172.25.129.161:8080/'
      imgfile = 'mainPlatform'
      break
    case 'igy.amoyiot.com': // i工业
      url = 'https://igy.amoyiot.com'
      zturl = 'https://igyzt.amoyiot.com/'
      hfurl = 'https://igyh5.amoyiot.com'
      imgfile = 'mainPlatform'
      break
    case 'jjyz.net': // 晋江一中
      url = 'https://user.topeti.com'
      zturl = 'https://mp.topeti.com/'
      hfurl = 'https://app.topeti.com'
      imgfile = 'mainPlatform'
      break
    case 'zhxy.jjyz.net': // 晋江一中
      url = 'https://zhxy.jjyz.net'
      zturl = 'https://zhxy.jjyz.net:8080/'
      hfurl = 'http://zhxy.jjyz.net'
      imgfile = 'mainPlatform'
      break
    case 'zhihui.xmycxx.com': // 英才学校
      url = 'https://zhihui.xmycxx.com'
      zturl = 'https://xiaoyuan.xmycxx.com/'
      hfurl = 'https://wz.xmycxx.com'
      imgfile = 'mainPlatform'
      break
    case 'www.xmycxx.com': // 英才学校
      url = 'https://zhihui.xmycxx.com'
      zturl = 'https://xiaoyuan.xmycxx.com/'
      hfurl = 'https://wz.xmycxx.com'
      imgfile = 'mainPlatform'
      break
    case 'cs.xmycxx.com': // 英才测试环境
      url = 'https://cs.xmycxx.com'
      zturl = 'https://zt.xmycxx.com/'
      imgfile = 'mainPlatform'
      break
    case 'zc.qzedu.cn': // 泉州教育局
      url = 'https://zc.qzedu.cn'
      zturl = 'https://zc.qzedu.cn:8080/'
      hfurl = 'http://wapzc.qzedu.cn'
      imgfile = 'mainPlatform'
      break
    case 'zhxy.xmxdzx.com': // 新店中学
      url = 'https://zhxy.xmxdzx.com'
      zturl = 'https://zhxy.xmxdzx.com:4443/'
      imgfile = 'mainPlatform'
      break
    case 'zhxyy.topeti.com': // 政和县医院
      url = 'https://zhxyy.topeti.com:6565'
      zturl = 'https://zhxyyzt.topeti.com:6565/'
      imgfile = 'mainPlatform'
      break
    case '10.129.103.204': // 政和县医院
      url = 'https://10.129.103.204:6677'
      zturl = 'https://zhxyyzt.topeti.com:6565/'
      imgfile = 'mainPlatform'
      break
    case '192.168.100.166':
      url = 'https://192.168.100.166:6677'
      zturl = 'https://zhxyyzt.topeti.com:6565/'
      imgfile = 'mainPlatform'
      break
    case 'h.lmu.cn': // 黎明大学
      url = `${protocol}//h.lmu.cn`
      zturl = `${protocol}//h.lmu.cn:${port}/`
      hfurl = 'http://m.lmu.cn'
      imgfile = 'mainPlatform'
      break
    case 'ldm.fzgledu.cn': // 古楼教育局
      url = 'https://ldm.fzgledu.cn'
      zturl = 'https://ldmzt.fzgledu.cn/'
      hfurl = 'https://ldmh5.fzgledu.cn'
      imgfile = 'mainPlatform'
      break
    case 'itayz.xmedu.cn': // 同安一中
      url = 'https://itayz.xmedu.cn'
      zturl = 'https://itayz.xmedu.cn:8080/'
      imgfile = 'mainPlatform'
      break
    case 'chemplatform.xmu.edu.cn': // 厦门大学化院
      url = 'https://chemplatform.xmu.edu.cn'
      zturl = 'https://chemdatabase.xmu.edu.cn/'
      imgfile = 'mainPlatform'
      break
    case 'ltest.topeti.com': // 林总专用测试域名
      url = 'https://ltest.topeti.com'
      zturl = 'https://ltest.topeti.com/'
      imgfile = 'mainPlatform'
      break
    case 'dm.topeti.com': // 郑工测试域名
      url = 'https://dm.topeti.com'
      zturl = 'https://dm.topeti.com/'
      imgfile = 'mainPlatform'
      break
    case 'wfjt.topeti.com': // 武发集团
      url = 'https://wfjt.topeti.com'
      zturl = 'https://wfjt.topeti.com/'
      imgfile = 'mainPlatform'
      break
    default:
      url = 'https://edu.topeti.com'
      zturl = 'https://edu.topeti.com/'
      hfurl = 'https://app.topeti.com'
      // url = 'https://user.topeti.com'
      // zturl = 'https://mp.topeti.com/'
      // hfurl = 'https://app.topeti.com'
      //       url = 'https://eduxm.topeti.com'
      // zturl = 'https://xmeduzt.topeti.com/'
      imgfile = 'mainPlatform'
      break
  }
  let cloudurl = url + '/wp/' // 网盘路径 (默认是阿里的网盘，其他平台有网盘需要在对应域名下修改)

  return { url: url, imgfile: imgfile, zturl: zturl, hfurl: hfurl, cloudurl }
}
export default util
